import classes from './MealItemForm.module.css';
import Input from '../UI/Input';
import { useRef, useState } from 'react';

export default function MealItemForm(props) {
  const [formIsValid, setFormIsValid] = useState(true);
  const amountInputRef = useRef();

  const submitHandler = event => {
    event.preventDefault();
    const enteredAmount = Number(amountInputRef.current.value);
    if (enteredAmount < 1 || enteredAmount > 5) {
      setFormIsValid(false);
      return;
    }
    setFormIsValid(true);
    props.onAddToCart(enteredAmount);
  };

  return (
    <form className={classes.form} onSubmit={submitHandler}>
      <Input
        ref={amountInputRef}
        label="Amount"
        input={{
          id: 'amount_' + props.id,
          type: 'number',
          min: '1',
          max: '5',
          step: '1',
          defaultValue: '1',
        }}
      />
      <button>+ Add</button>
      {!formIsValid && <p>Please enter a valid amount (1-5)</p>}
    </form>
  );
}
